import { render, staticRenderFns } from "./OnboardingSponsors.vue?vue&type=template&id=06b4f6d1&"
import script from "./OnboardingSponsors.vue?vue&type=script&lang=js&"
export * from "./OnboardingSponsors.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingSponsors.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../Volumes/Work/Work/gerocare/CrmWeb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports